import { render, staticRenderFns } from "./infoFormEdit.vue?vue&type=template&id=4afad10e&scoped=true"
import script from "./infoFormEdit.vue?vue&type=script&lang=js"
export * from "./infoFormEdit.vue?vue&type=script&lang=js"
import style0 from "./infoFormEdit.vue?vue&type=style&index=0&id=4afad10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afad10e",
  null
  
)

export default component.exports